import React from "react";

import { keyGenerator } from "../../../libs/Util";
import Class from "../../../molecules/teacher/Class";
import { IGrade } from "../../../pages/teacher/types";

import styles from "./GroupClass.module.scss";

export type Props = {
  listClass: IGrade[];
  forward?: boolean;
  forwardData?: boolean;
  listClassesSelected?: number[];
  onChooseClass?: (id: number, assumed_entrance_year?: number) => void;
};

const GroupClass: React.FC<Props> = ({
  listClass,
  forward = false,
  forwardData = false,
  listClassesSelected = [],
  onChooseClass,
}) => {
  return (
    <div className={styles.groupClass}>
      {listClass.map(group => (
        <div className={styles.block} key={keyGenerator(group)}>
          <p className={styles.grade}>{group.grade} 年生</p>
          {group.classes.map(item => (
            <Class
              item={item}
              key={item.id}
              forward={forward}
              forwardData={forwardData}
              isActive={listClassesSelected.some(id => id === item.id)}
              onChooseClass={onChooseClass}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default GroupClass;
